import { FC } from "react";

import { PrimaryText } from "@/shared/ui/Typography";
import { RequestQueueItemMetadata } from "@/types/requestQueue";

interface QueueItemMetadataProps {
    metadata: RequestQueueItemMetadata;
}

export const QueueItemMetadata: FC<QueueItemMetadataProps> = ({ metadata }) => {
    const { taskName, pointName, title } = metadata;

    return (
        <>
            {title && <PrimaryText fontWeight="500">{title}</PrimaryText>}

            {taskName && <PrimaryText fontWeight="500">{taskName}</PrimaryText>}

            {pointName && <PrimaryText>{pointName}</PrimaryText>}
        </>
    );
};
